export default __webpack_public_path__ + "static/media/notification-success.36bbe66a.svg";